import { useEffect, useState } from 'react';
import { CountPendingClaimRequest } from '../../../application/ClaimRequest/CountPendingClaimRequest';
import { NumberOfPendingClaimRequest } from '../../../domain/values/NumberOfPendingClaimRequest';
import { ClaimRequestNomaRepository } from '../../../infraestructure/repositories/claimRequest/ClaimRequestNomaRepository';

const countPendingClaimRequest = new CountPendingClaimRequest(ClaimRequestNomaRepository);
export const useCountPendingClaimRequests = (countryCode: string) => {
    const [numberOfPendingClaimRequest, setNumberOfPendingClaimRequest] = useState<NumberOfPendingClaimRequest>({
        oldestDateOfNewIncidents: undefined,
        numberOfNewIncidents: 0,
        numberOfNewIncidentsReserved: 0,
        numberOfNewPreventionClaims: 0,
        numberOfNewPreventionClaimsReserved: 0,
        oldestDateOfNewPreventionClaims: undefined,
        numberOfNewAssessmentsGlobal: 0,
        numberOfNewAssessmentsGlobalReserved: 0,
        oldestDateOfNewAssessmentsGlobal: undefined,
        numberOfOnHoldClaimRequestGlobal: 0,
        oldestDateOfOnHoldClaimRequestGlobal: undefined,
        numberOfReadyToReviewIncidentsGlobal: 0,
        numberOfReadyToReviewIncidentsGlobalReserved: 0,
        oldestDateOfReadyToReviewIncidentsGlobal: undefined,
        numberOfPreventionClaimsWithNewDocumentationGlobal: 0,
        numberOfPreventionClaimsWithNewDocumentationGlobalReserved: 0,
        oldestDateOfPreventionClaimsWithNewDocumentationGlobal: undefined,
    });

    useEffect(() => {
        countPendingClaimRequest.execute(countryCode).then(setNumberOfPendingClaimRequest);
    }, [countryCode]);

    return numberOfPendingClaimRequest;
};
